import { render } from "./CustomerInfoTable.vue?vue&type=template&id=81549618"
import script from "./CustomerInfoTable.vue?vue&type=script&lang=js"
export * from "./CustomerInfoTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__